module.exports = __webpack_public_path__ + "img/h_logo.cbc5e4b8.png";